import billing_theme from "style/theme_colors";
import styled from "styled-components";

export const FaturaListEmptyContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  background: ${billing_theme.pallete.tertiary.A25};
  width: 98%;
  margin: 0 auto;
  padding: 50px 0px;
  border-radius: 12px;
  -webkit-box-shadow: 0px 0px 24px 1px rgba(190, 190, 190, 0.3803921569);
  -moz-box-shadow: 0px 0px 24px 1px rgba(190, 190, 190, 0.3803921569);
  box-shadow: 2px 4px 4px 0px ${billing_theme.pallete.box_shadow};
  height: 100%;
  margin-top: 0px;
  margin-bottom: 16px;

  img {
    width: 250px;
  }
  .text {
    text-align: center;
    padding: 0px 22%;
  }

  .text h5 {
    line-height: 22px;
  }
`;
